import Vue from 'vue'
import { Calendar, DatePicker } from 'v-calendar'

/**
 * Register the global v-calendar component.
 */
Vue.component('Calendar', Calendar)
Vue.component('DatePicker', DatePicker)

export default {
	components: {
		Calendar,
		DatePicker,
	},
}
